import Box from 'common/components/Box';
import Heading from 'common/components/Heading';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import {
  PiArticle,
  PiBowlFood,
  PiCalendarCheck,
  PiChatCircleDots,
  PiIdentificationCard,
  PiMapPinLine,
  PiShoppingBag,
  PiStorefront,
} from 'react-icons/pi';
import Fade from 'react-reveal/Fade';
import { Figure, Grid, SectionHeading } from './everNeed.style';

const careIcons = {
  article: PiArticle,
  calendar: PiCalendarCheck,
  food: PiBowlFood,
  lostFound: PiMapPinLine,
  marketplace: PiShoppingBag,
  message: PiChatCircleDots,
  profile: PiIdentificationCard,
  services: PiStorefront,
};

const EverNeed = (props) => {
  const data = useStaticQuery(graphql`
    query {
      appJson {
        everNeed {
          background
          iconName
          id
          title
        }
      }
    }
  `);
  const items = data?.appJson?.everNeed;

  return (
    <div {...props}>
      <SectionHeading>
        <Heading content="Everything you need for modern pet care" />
      </SectionHeading>
      {items?.length > 0 ? (
        <Fade up>
          <Grid>
            {items.map((item) => {
              const CareIcon = careIcons[item?.iconName] || PiIdentificationCard;
              return (
                <Box
                  className="icon-box-item"
                  key={item?.id}
                  style={{ '--backgroundColor': item?.background }}
                >
                  <Figure aria-hidden="true">
                    <CareIcon />
                  </Figure>
                  {item?.title}
                </Box>
              );
            })}
          </Grid>
        </Fade>
      ) : null}
    </div>
  );
};

export default EverNeed;
